export class UrlHelper {
    static host(input: string) {
        const trimmed = input.trim();

        const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;

        const url = new URL(withScheme);
        return url.host;
    }
}